import { fetch } from '@/shared/fetch';
import {
    IOpenVideoConsultationRequest,
    IOpenVideoConsultationResult,
} from '@/shared/interfaces';

export const createVideoConsultation = async (
    request: IOpenVideoConsultationRequest,
): Promise<IOpenVideoConsultationResult> => {
    return await fetch('/api/consultations/video', 'POST', request);
};
